import { useState } from "react";
import { RiSettings4Line, RiFlowChart } from "react-icons/ri";
import SegmentationRules from "../components/recipients/SegmentationRules";
import CustomTriggers from "../components/automation/CustomTriggers";

const AutomationSettings = () => {
  const [activeTab, setActiveTab] = useState("segmentation");

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-secondary-900">
          Automation Settings
        </h1>
      </div>

      <div className="flex space-x-4 border-b border-secondary-200">
        <button
          className={`px-4 py-2 font-medium flex items-center ${
            activeTab === "segmentation"
              ? "text-primary-600 border-b-2 border-primary-600"
              : "text-secondary-600 hover:text-secondary-900"
          }`}
          onClick={() => setActiveTab("segmentation")}
        >
          <RiSettings4Line className="w-5 h-5 mr-2" />
          Segmentation Rules
        </button>
        <button
          className={`px-4 py-2 font-medium flex items-center ${
            activeTab === "triggers"
              ? "text-primary-600 border-b-2 border-primary-600"
              : "text-secondary-600 hover:text-secondary-900"
          }`}
          onClick={() => setActiveTab("triggers")}
        >
          <RiFlowChart className="w-5 h-5 mr-2" />
          Custom Triggers
        </button>
      </div>

      {activeTab === "segmentation" ? (
        <SegmentationRules />
      ) : (
        <CustomTriggers />
      )}
    </div>
  );
};

export default AutomationSettings;
